import { render, staticRenderFns } from "./ContainerSpeakers.vue?vue&type=template&id=8e581460&scoped=true&"
import script from "./ContainerSpeakers.vue?vue&type=script&lang=js&"
export * from "./ContainerSpeakers.vue?vue&type=script&lang=js&"
import style0 from "./ContainerSpeakers.vue?vue&type=style&index=0&id=8e581460&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e581460",
  null
  
)

export default component.exports